const commonSetting = {
  apstag: true
}
const atfSizeMapping = [
  { displaySize: [992, 400], adSize: [[320, 50], [320, 100], [468, 60], [640, 100], [728, 90]] },
  { displaySize: [0, 0], adSize: [[320, 50], [320, 100]] }
]

const gptConf = [
  { ...commonSetting, unitCode: '/284705699/2.5web/2.5web_clothes_atf', size: [[320, 50], [320, 100], [468, 60], [640, 100], [728, 90]], mapping: atfSizeMapping, slotId: '2.5web_clothes_atf' },
  { ...commonSetting, unitCode: '/284705699/2.5web/2.5web_clothes_btf', size: [[336, 280], [320, 50], [300, 250], [320, 100], [200, 200]], slotId: '2.5web_clothes_btf' },
  { ...commonSetting, unitCode: '/284705699/2.5web/2.5web_clothes_btm', size: [[160, 600], [300, 250], [200, 200], [120, 600], [336, 280], [300, 600]], slotId: '2.5web_clothes_btm' },

  { ...commonSetting, targeting: { category: 'clothes' }, unitCode: '/284705699/2.5web/2.5web_sticky_web', size: [320, 50], slotId: 'div-gpt-ad-sticky', sticky: true, targetPlatform: 'sp', hasParent: true },
  { ...commonSetting, targeting: { category: 'clothes' }, unitCode: '/284705699/2.5web/2.5web_stickyad_pc', size: [[970, 90], [640, 100], [728, 90], [640, 50], [950, 70], [950, 90]], slotId: 'div-gpt-ad-1666850974098-0', sticky: true, targetPlatform: 'pc', hasParent: true }
]
export const adsConfig = {
  gptConf,
  usePrebids: true,
  lazyload: true
}
